import { Link, NavLink } from 'react-router-dom'
import './index.scss'
import LogoS from '../../assets/images/logo-s.png'
import LogoSubtitle from '../../assets/images/logo_sub.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faHome, faProjectDiagram, faUser } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin, faQq } from '@fortawesome/free-brands-svg-icons'

const Sidebar = () => (
    <div className='nav-bar'>
        <Link className='logo' to ='/'>
            <img src = {LogoS} alt="logo" />
            <img class= "sub-logo" src = {LogoSubtitle} alt="zhihao" />
        </Link>
        <nav>
        <NavLink exact="true" activeclassname = "active" to="/">
            <FontAwesomeIcon icon = {faHome} color="#4d4d4e" />
        </NavLink>
        <NavLink exact="true" activeclassname = "active" className="about-link" to="/about">
            <FontAwesomeIcon icon = {faUser} color="#4d4d4e" />
        </NavLink>
        <NavLink 
            exact="true" 
            activeclassname = "active" 
            className="experience-link" 
            to="/experience"
        >
            <FontAwesomeIcon icon = {faProjectDiagram} color="#4d4d4e" />
        </NavLink>
        <NavLink 
            exact="true" 
            activeclassname = "active" 
            className="contact-link" 
            to="/contact"
        >
            <FontAwesomeIcon icon = {faEnvelope} color="#4d4d4e" />
        </NavLink>
        </nav>
        <ul>
            <li>
                <a target="_blank" rel='noreferrer' href='https://www.linkedin.com/in/zhihao-wang-958331193/'>
                    <FontAwesomeIcon icon ={faLinkedin} color="#4d4d4e">

                    </FontAwesomeIcon>
                </a>
            </li>
            <li>
                <a target="_blank" rel='noreferrer' href='https://github.com/wangz35'>
                    <FontAwesomeIcon icon ={faGithub} color="#4d4d4e">

                    </FontAwesomeIcon>
                </a>
            </li>
            <li>
                <a target="_blank" rel='noreferrer' href='1115003227'>
                    <FontAwesomeIcon icon ={faQq} color="#4d4d4e">

                    </FontAwesomeIcon>
                </a>
            </li>
        </ul>
    </div>
)

export default Sidebar;